import FormOwnerProfile from './FormOwnerProfile';

export default FormOwnerProfile;